import delegate from '../helpers/delegate-it';
import View from './View';
import Btn from '../../components/Btn';
import Field from '../../components/Field';
import Form from '../../components/Form';
import Hero from '../../components/Hero';
import Slider from '../../components/Slider';
import FilterBar from '../../components/FilterBar';
// import Selector from '../../components/Selector';
import Popper from '../../components/Popper';
import Recaptcha from '../../components/Recaptcha';
import Sharer from '../../components/Sharer';
import ListingPageTemplate from '../../templates/ListingPageTemplate';
import AskForAQuoteStep1 from '../../pages/AskForAQuoteStep1';
import CookieConsent from '../../components/CookieConsent';
import Collapse from '../../components/Collapse';

export default {
    get views() {
        return [
            Btn,
            Field,
            Form,
            Hero,
            Slider,
            FilterBar,
            // Selector,
            Popper,
            Recaptcha,
            Sharer,
            CookieConsent,
            Collapse,
            ListingPageTemplate,
            AskForAQuoteStep1,
        ];
    },
    start() {
        if (!this._isSupported()) {
            return;
        }

        document.querySelector('html')?.classList?.add('has-components-support');

        this._setupViews();
        this._setupEvents();
    },
    _isSupported() {
        return (
            (('classList' in document.documentElement) && !!document.documentElement.classList.replace)
            && (('isEqualNode' in document.documentElement) && ('isSameNode' in document.documentElement))
            && (!!Object.entries && !!Object.values)
            && (!!String.prototype.includes && !!Array.prototype.includes)
            && (('Map' in window) && !!Map.prototype.entries)
            && (('Set' in window) && !!Set.prototype.entries)
            && (('CustomEvent' in window) && !!CustomEvent.prototype.constructor)
            && ('content' in document.createElement('template'))
        );
    },
    _setupViews() {
        View.initInstances('[data-view-name]', this.views);
    },
    _setupEvents() {
        const eventTypes = [
            'blur',
            'change',
            'click',
            // 'contextmenu',
            // 'dblclick',
            // 'focus',
            'input',
            // 'keyup',
            'submit',
        ];

        eventTypes.forEach(eventType => {
            delegate(document.body, '[data-view-name]', eventType, (e) => {
                View.instances.forEach(instance => {
                    const target = e.delegateTarget;

                    if (target.disabled) {
                        return;
                    }

                    instance.triggerEventHandlers(e);
                });
            });
        });
    },
}